export const PAYMENT_REQUIRED_EVENT = 'quazbit:payment-required';
export const BILLING_TOAST_STORAGE_KEY = 'quazbit_billing_toast';

const BILLING_PATH = '/account-setting';
const SELECT_PLAN_PATH = '/select-plan';
const BILLING_HREF = '/account-setting?tab=billing';
const SELECT_PLAN_HREF = '/select-plan?from=billing';

/** Statuses that block writes after trial/subscription ends. */
export const BILLING_INACTIVE_STATUSES = new Set(['past_due', 'canceled']);

export function isBillingInactive(status) {
    return BILLING_INACTIVE_STATUSES.has(String(status || '').toLowerCase());
}

export function isOnBillingOrSelectPlan(pathname = window.location.pathname, search = window.location.search) {
    const path = pathname || '';
    const params = new URLSearchParams(search || '');
    if (path === SELECT_PLAN_PATH || path.startsWith(`${SELECT_PLAN_PATH}/`)) return true;
    return path === BILLING_PATH && params.get('tab') === 'billing';
}

export function resolvePaymentRequiredAction(error) {
    if (error?.response?.status !== 402) return null;

    const data = error.response.data || {};
    const code = data.code;
    const message = typeof data.message === 'string' ? data.message : '';
    const isLimit =
        code === 'PLAN_LIMIT_REACHED' || /upgrade your plan/i.test(message);

    if (isLimit) {
        return {
            code: 'PLAN_LIMIT_REACHED',
            message: message || 'Upgrade your plan to continue.',
            target: SELECT_PLAN_HREF,
        };
    }

    return {
        code: 'BILLING_WRITE_BLOCKED',
        message:
            message ||
            'Your subscription is inactive. Update billing to continue making changes.',
        target: BILLING_HREF,
    };
}

export function consumePendingBillingToast() {
    try {
        const raw = sessionStorage.getItem(BILLING_TOAST_STORAGE_KEY);
        if (!raw) return null;
        sessionStorage.removeItem(BILLING_TOAST_STORAGE_KEY);
        const parsed = JSON.parse(raw);
        if (parsed?.message) return parsed;
    } catch {
        /* ignore */
    }
    return null;
}

export function handlePaymentRequiredResponse(error) {
    const action = resolvePaymentRequiredAction(error);
    if (!action) return false;

    const stayPut = isOnBillingOrSelectPlan();
    if (!stayPut) {
        try {
            sessionStorage.setItem(
                BILLING_TOAST_STORAGE_KEY,
                JSON.stringify({ message: action.message, type: 'warning' }),
            );
        } catch {
            /* ignore */
        }
    }

    if (typeof window !== 'undefined') {
        window.dispatchEvent(
            new CustomEvent(PAYMENT_REQUIRED_EVENT, {
                detail: {
                    ...action,
                    navigate: !stayPut,
                },
            }),
        );
    }

    return true;
}
